<template>
  <div class="h-app-header-model">
    <div class="hahm-logo-area">
      <span class="hahm-logo">
        <img
          alt="title"
          src="data:image/png;base64,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"
        />
      </span>
      <span class="hahm-text-1">商户平台</span>
    </div>
    <div class="hahm-toggle-business" v-if="!isErp">
      <el-dropdown
        trigger="click"
        placement="bottom"
        @command="onBusinessCommand"
        class="hahm-dropdown"
      >
        <el-button size="mini">
          <div style="display: flex;align-items: center;">
            <div style="margin-right: 4px;font-size: 16px;">{{ merName }}</div>
            <i
              class="el-icon-arrow-down el-icon--right"
              style="color: #fff;font-size: 20px"
            ></i>
          </div>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in merchantList"
            :key="item.value"
            :command="item.value"
          >
            <i class="el-icon-s-shop" style="margin-right: 8px"></i
            >{{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 新微商城客服 -->
    <!-- <div v-if="csInfo">
      <m-cs-im v-if="csInfo && (accInfo.admin !== 1)"/>
      <m-mt-im v-if="csInfo && csInfo.mtStatus === 1"/>
    </div> -->
    <div class="hahm-user-box">
      <m-monitor></m-monitor>
      <div class="hahm-user">
        <img
          v-if="!isAvatar && userInfo.merLogo"
          class="user-avatar"
          :src="showImg(userInfo.merLogo)"
          @error="_onErrorAvatar"
          size="24"
        />
        <div class="user-name">{{ userInfo.merName || userInfo.account }}</div>
        <el-dropdown trigger="click" @command="onUserCommand">
          <span class="el-dropdown-link">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="user-center" v-if="!isErp"
              ><span style="display: inline-block"
                >个人中心</span
              ></el-dropdown-item
            >
            <el-dropdown-item command="print-service"
              ><span style="display: inline-block"
                >打印服务</span
              ></el-dropdown-item
            >
            <el-dropdown-item command="log-out"
              ><span style="display: block">退出</span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog
      class="m-el-dialog"
      title="打印服务"
      width="520px"
      :visible.sync="visiblePrint"
    >
      <m-print-service v-if="visiblePrint"></m-print-service>
    </el-dialog>
  </div>
</template>
<script>
import MC from '@/module/MC'
import { mapMutations, mapState } from 'vuex'
import { addCSS } from '@/module/utils'
import mMtIm from '@/module/components/mtIm/mtIm'
import { appInfos } from '@/module/singleSpa/appInfos'
import mMonitor from '@/module/components/monitor'
import {
  getBusinessData,
  switchBusiness,
  getBusinessInfo
} from '@/module/apis/user'
// import mCsIm from '@/module/components/csIm/csIm'
import CsdStaffService from '@/module/apis/csdStaffService'
import mPrintService from './printService'

export default {
  name: 'h-app-header',
  data () {
    return {
      isAvatar: false,
      merName: '',
      userInfo: {},
      merchantList: [],
      visiblePrint: false
    }
  },
  props: {},
  methods: {
    ...mapMutations('meituanIM', ['setIMWebsocket']),
    ...mapMutations('cs', ['setCsInfo']),
    getCsInfo () {
      CsdStaffService.querySingleStaff()
        .then(res => {
          this.setCsInfo(res)
        })
        .catch(e => {
          console.log(e)
        })
    },
    onConsultation () {
      this.$router.push('/app-customer-service/consulting')
    },
    onUserCommand (v) {
      if (v === 'user-center') {
        this.$router.push({ path: `/app-users/personal` })
        return
      }
      if (v === 'log-out') {
        this.$store.dispatch('common/logOut')
      }
      if (v === 'print-service') {
        this.visiblePrint = true
      }
    },
    onBusinessCommand (merCode) {
      switchBusiness({ merCode }).then(async res => {
        const { userName, token, allHasSys } = res
        const { system } = MC.config
        if (_.some(allHasSys, { reEngSystem: system })) {
          await MC.setConfig({ userName, merCode })
          await MC.setAuth(token)
          this.getMerName(merCode)
          const pathCode = _.split(this.$route.path, '/')[1]
          const pathSubsys = _.replace(this.$route.path, pathCode, '')
          const sysItem = _.find(appInfos, { name: pathCode })
          if (sysItem) {
            getBusinessInfo(sysItem.system).then(req => {
              const authList = MC.parsingSystemLabel(req.resList)
              if (authList.includes(pathSubsys)) {
                window.location.reload()
              } else {
                window.location.href = '/home'
              }
            })
          } else {
            window.location.reload()
          }
        } else {
          MC.setConfig({ system: allHasSys[0].reEngSystem })
          window.location.href = '/home'
        }
      })
    },
    getMerName (merCode) {
      this.merName = this.merchantList.find(v => v.value === (merCode || this.merCode))['label'] || ''
    },
    _onErrorAvatar (e) {
      if (e) {
        this.isAvatar = true
      }
    }
  },
  watch: {},
  beforeCreate () {},
  created () {
    const { userInfo } = MC.config
    this.userInfo = userInfo
    // this.getCsInfo()

    getBusinessData().then(res => {
      if (!res) {
        return
      }
      this.merchantList = _.map(res, v => {
        return { value: v.merCode, label: v.merName }
      })

      this.merCode = _.some(this.merchantList, { value: userInfo.merCode })
        ? userInfo.merCode
        : 'no-merCode'

      MC.setConfig({
        merCode: this.merCode
      })

      if (this.merchantList.length) {
        this.getMerName()
      }
    })
  },
  beforeMount () {},
  mounted () {
    addCSS(
      `.el-table,.h-app-main-model{ background:url(${global.watermark}) !important} .el-table__fixed-right,.el-table__fixed {background:#fff !important}`
    )
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  computed: {
    ...mapState('common', ['accInfo', 'isErp']),
    ...mapState('meituanIM', ['currentCsMtStatus', 'currentCsStatus']),
    ...mapState('customerService', ['webSocketConnected']),
    ...mapState('cs', ['csInfo'])
  },
  // components: { mMtIm, mMonitor, mCsIm, mPrintService }
  components: { mMtIm, mMonitor, mPrintService }
}
</script>

<style lang="scss" rel="stylesheet/scss">
.h-app-header-model {
  position: relative;
  .hahm-logo-area {
    width: 255px;
    text-align: center;
    padding: 16px 0;
    .hahm-logo {
      > img {
        width: 27px;
        height: 31px;
        vertical-align: middle;
      }
    }
    .hahm-text-1 {
      color: #ffffff;
      font-size: 18px;
      padding-left: 8px;
      vertical-align: middle;
    }
  }
  .hahm-toggle-business {
    position: absolute;
    left: 300px;
    top: 13px;
    .el-button {
      background: none;
      border-color: #4a5060;
      color: #fff;
      font-size: 20px;
      font-weight: normal;
    }
  }
  .hahm-user-box {
    position: absolute;
    right: 20px;
    top: 14px;
    .hahm-consulting {
      display: inline-block;
    }
    .hahm-user {
      display: inline-block;
      margin-left: 20px;
      .user-avatar,
      .user-name,
      .icon {
        vertical-align: middle;
        font-size: 14px;
        color: #fff;
        display: inline-block;
      }
      i {
        font-size: 16px;
        color: #fff;
      }
      .user-avatar {
        width: 24px;
        height: 24px;
        border-radius: 17px;
      }
      .user-name {
        padding: 0 3px 0 8px;
        height: 28px;
        line-height: 28px;
        color: #fff;
      }
    }
  }
}
</style>
<style lang="scss">
.m-el-dialog {
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/header.vue